<script setup lang="ts">
defineProps<{
  categories: { id: string; label: string }[]
  selectedCategory: string
}>()

const emit = defineEmits<{
  (e: 'selectCategory', categoryId: string): void
}>()
</script>

<template>
  <div class="mb-6 flex flex-wrap gap-2.5">
    <button
      v-for="filter in categories"
      :key="filter.id"
      type="button"
      :class="[
        'flex items-center justify-center gap-2.5 rounded-full px-3.5 py-2 text-sm font-medium leading-6 transition-colors cursor-pointer',
        selectedCategory === filter.id
          ? 'bg-primary text-white'
          : 'bg-primary/10 text-foreground hover:bg-primary hover:text-white'
      ]"
      @click="emit('selectCategory', filter.id)"
    >
      {{ filter.label }}
      <slot name="label" :filter="filter" />
    </button>
  </div>
</template>
